import * as React from "react";
import * as ReactDOM from "react-dom";

interface KeywordPromptsPromptDisplayProps {
  label?: string;
  keywords: string[];
  prompt: string;
}

export const KeywordPromptsPromptDisplay = (
  props: KeywordPromptsPromptDisplayProps,
): JSX.Element => {
  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        {props.label && <span className="italic font-bold">{props.label}</span>}
        <p className="flex-shrink-0 italic">You just mentioned</p>
        <div className="flex flex-wrap gap-2">
          {props.keywords.map((keyword, i) => (
            <div key={i} className="chip">
              {keyword}
            </div>
          ))}
        </div>
      </div>
      <p className="italic">
        Do you have <span className="chip not-italic">{props.prompt}</span> to
        share?
      </p>
    </div>
  );
};

document
  .querySelectorAll<HTMLElement>(".keyword-prompts-prompt")
  .forEach((keywordPromptsPrompt) => {
    ReactDOM.render(
      <KeywordPromptsPromptDisplay
        label={keywordPromptsPrompt.dataset.label as string}
        keywords={(keywordPromptsPrompt.dataset.keywords as string)
          .split("\n")
          .filter((k) => k)}
        prompt={keywordPromptsPrompt.dataset.prompt as string}
      />,
      keywordPromptsPrompt,
    );
  });
